import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Alert
} from "reactstrap";
import "../../styles/estilos.css";
import { withRouter } from "react-router-dom";
import { fetchCalcularCotizacionAP, datosCarritoAPTravelGroup, fetchGuardarEmisionRetroactiva } from "../../redux/actions/aRamoAccidentesPersonales";
import { Textbox,Textarea } from "react-inputs-validation";

import { connect } from "react-redux";
import { urlGuardarPasoHogar } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import moment from "moment";


class ValoresCotizacionAPersonal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante",
      correo: "",
      visibleAlert: true,
      terminosHabilitado: this.props.paso === "confirmacion-cotizacion" ? false : true,
      validate: false,
      hasCorreoError: true,
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }


  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  }


  voverCotizar(){
    this.props.history.push({
      pathname: "/cotizacion-accidente"
    });
  }


  onChangeCorreo = (event) => {
    event.preventDefault();

      this.setState({
        correo:event.target.value
      })

  }

  onClickEnviar(event){

    const {correo, hasCorreoError} = this.state

    console.log(hasCorreoError)

    if(correo && correo!=='' && correo!==null && hasCorreoError===false){
      this.props.metodoEnviar(event, this.state.correo);
    }
   
  }
 

  onClick = async (event) => {
    event.preventDefault();

    if(this.props.formEditado){
                this.props.accion()
    }else{
        
    }
   

  }

  
  onClickSiguiente = async () => {  
    const {idCarrito, requiereEmision, vigenciaRetroactiva, errorVigenciaRetroactiva} = this.props

    if (requiereEmision && errorVigenciaRetroactiva) {
      return false
    }

    if(requiereEmision){
      await this.props.guardarEmisionRetroactiva({
        "empresa": "AIGMETROPOLITANA",
        "plataforma": "WEB",
        "idCarrito": idCarrito,
        "fechaEmisionRetroactivaFutura":moment(new Date(vigenciaRetroactiva)).format('DD/MM/YYYY') ,
        "emisionRetroactivaFutura": requiereEmision
      })
    }


    let resp = await FetchPost({
      url: urlGuardarPasoHogar, param: {
        empresa:"AIGMETROPOLITANA",
        idcarrito:idCarrito,
        paso:"4",
        mensaje:"Ingreso de Datos de Facturación",
        codigoPasoActual:"datosFacturacionTravel",
        plataforma:"WEB"
      }})
    const { transaccion } = resp
    if (transaccion) {
      this.props.history.push({
        pathname: "/datos-facturacion",
        search: `?id=${idCarrito}`,
        state: { path: this.props.location.pathname, search:  this.props.location.search }
      });
    }

   
  }
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {      
      if (this.props.detalleCarrito && this.props.detalleCarrito.productosCarrito.carProductos.length > 1) {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen-multi'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
      else {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
    }
    else {
      if (windowBottom >= (docHeight - 120)) {
        this.setState({
          claseDivFix: 'flex-row div-flotante fix-botton-totales'
        });        
      } else {
        this.setState({
          claseDivFix: 'flex-row div-flotante'
        });
      }
    }
  }
   
  onClickDescargar = (event) => {
    event.preventDefault()
    this.props.metodoDescargar(event);
  }


  async componentDidMount() {
    window.scroll(0, 0);  
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {

    const {primaNeta, primaTotal, sumaImpuestos, impuestos} = this.props
    const { correo, terminosHabilitado, claseDivFix} = this.state;
  
    return (
      <Card className={this.state.claseDivFix}>
        <CardBody>
          <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
          <Row>

            
            <Col lg={6} md={6} sm={6} xs={6} >
              <h4>Prima Neta por Póliza</h4>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
            <h5>$ {primaNeta}</h5>
            </Col>
          </Row>
          <Row>
            <div id="container-imp">
              <div className="accordion-imp">
                <input type="checkbox" id="tm" />
                <label htmlFor="tm" className="accordionitem">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h4 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                        Impuestos{" "}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </h4>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>$ {sumaImpuestos}</h5>
                    </Col>
                  </Row>
                </label>
                <div className="hiddentext ocultar">


                    {impuestos && impuestos.map(
                        impuesto=>(
                            <Row key={impuesto.nombre}>
                            <Col lg={6} md={6} sm={6} xs={6}>
                            <h5>{impuesto.nombre}</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${impuesto.valor}</h5>
                            </Col>
                          </Row>    
                        )
                    )}

                    
                               

                </div>
                
              </div>
            </div>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>Prima Total por Póliza</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
                 <h5 style={{ fontWeight: "bold" }}>$ {primaTotal}</h5>
            </Col>
          </Row>
          <hr />

          <Row> 
            <Col lg={12} md={12} sm={12} xs={12}>
            <Button
              className={
                this.props.formEditado
                  ? "btn btn-primary btn-purple fe-pulse"
                  : "btn btn-primary"
              }
              onClick={this.props.formEditado && this.props.hasNumDiasError==false?this.onClick: this.props.hasNumDiasError==false?this.onClickSiguiente:''}
              style={{ display: "block", margin: "auto" }}
              
            >
              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
              {this.props.formEditado? "ACTUALIZAR": ' INICIAR EMISIÓN'}

            </Button>  
            {/*<Button
              className={
                 "btn btn-primary btn-purple"
              }

              onClick={this.voverCotizar}
              
              style={{ display: "block", margin: "auto" }}
              
            >
              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}

              {'VOLVER A COTIZAR'}

            </Button> */}
            {this.props.linkDescarga && (
                  <a
                    className="btn btn-detail-white"
                    style={{ marginTop: "30px" }}
                    href={this.props.linkDescarga}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-cloud-download" aria-hidden="true"></i>{" "}
                    DESCARGAR COTIZACIÓN
                  </a>
                )}


                  {/* <Button className="btn btn-detail-white" style={{marginTop:'40px'}} onClick={this.onClickDescargar}>
                  <i className="fa fa-cloud-download" aria-hidden="true" /> DESCARGAR COTIZACIÓN
                </Button>  */}
                <br></br>
              </Col>
            </Row>

            <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              
                {this.props.okDescarga && this.props.linkDescarga &&
                  <a href={this.props.linkDescarga} target="_blank" rel="noopener noreferrer"> Click para descargar</a>}
              </Col>
            </Row>


            <Row>

                <Col lg={8} md={12} sm={12} xs={12}>



                <Textbox
                                tabIndex="1"
                                type="input"
                                value={correo}
                                name="correo"
                                id="correo"
                                classNameInput={"form-control"}
                                onChange={(correo, e) => {
                                this.setState({ correo});
                                }}
                                placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                                validate={this.state.validate}
                                validationCallback={res => {
                                this.setState({
                                    hasCorreoError: res,
                                    validate: !res
                                })
                                }
                                } // Optional.[Func].Default: none. Return the validation result.



                                onBlur={e => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} 

                                validationOption={{
                                    name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true,
                                    reg:   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    regMsg:'Por favor ingrese un correo válido',
                                    msgOnError: "Por favor ingrese un correo válido" // Optional.[Bool].Default: true. To determin if it is a required field.
                                }}
                            />


                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <Button className="btn btn-detail-white" onClick={this.onClickEnviar.bind(this)}>
                    <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                </Button>

                </Col>
                {this.props.okEnvio &&
                  <Alert color="success" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                    <center><p>Se ha enviado correctamente la cotización al correo electrónico ingresado.</p></center>
                  </Alert>
                }
                </Row>       
          
          
        </CardBody>
      </Card>
    );
  }
}


const mapStateToProps = state => ({
    datosCalculosCotizacionAP : state.datosCalculosCotizacionAP,
    datosCarritoAPTravelGroup : state.datosCarritoAPTravelGroup
});
const mapDispatchToProps = dispatch => {
  return {
    calculoCotizacion: datos => dispatch(fetchCalcularCotizacionAP(datos)),
    guardarEmisionRetroactiva: datos => dispatch(fetchGuardarEmisionRetroactiva(datos)),
    
  };
};


export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ValoresCotizacionAPersonal)
  );
  